import { Head, Link, useForm } from "@inertiajs/react"
import type { FormEvent } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"
import { AuthLayout } from "@/layouts/auth-layout"

interface ForgotPasswordProps {
  flash?: { alert?: string }
}

function ForgotPassword({ flash }: ForgotPasswordProps) {
  const { data, setData, post, processing } = useForm({
    email_address: "",
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post("/passwords")
  }

  return (
    <>
      <Head title="Mot de passe oublié" />
      <Card className="w-full pt-4">
        <CardHeader>
          <CardTitle className="text-center">Mot de passe oublié ?</CardTitle>
          <CardDescription className="text-center">
            Entrez votre email pour recevoir les instructions de réinitialisation
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-4">
          <div className="min-h-5 text-sm text-center">
            {flash?.alert && <p className="text-destructive">{flash.alert}</p>}
          </div>
          <form onSubmit={handleSubmit} className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="email_address">Email</Label>
              <Input
                id="email_address"
                type="email"
                placeholder="vous@exemple.com"
                value={data.email_address}
                onChange={(e) => setData("email_address", e.target.value)}
                required
                autoFocus
                autoComplete="username"
              />
            </div>
            <Button type="submit" size="lg" disabled={processing} className="w-full">
              {processing ? "Envoi..." : "Envoyer les instructions"}
            </Button>
          </form>
        </CardContent>
        <CardFooter className="justify-center">
          <Link href="/session/new" className="text-sm text-muted-foreground hover:underline">
            Retour à la connexion
          </Link>
        </CardFooter>
      </Card>
    </>
  )
}

ForgotPassword.layout = (page: React.ReactNode) => <AuthLayout>{page}</AuthLayout>

export default ForgotPassword
